var exports = {
  "x": "ExpiryFootnote.module__footnote___Snkza2",
  "m": "ExpiryFootnote.module__inlineFootnote___Snkza2",
};

module.exports = exports;
